module.exports = "<a class=\"clearfix\">\n  <span class=\"pull-left\">{{match.model.Name}}</span>\n</a>\n";